import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from './ui/badge';
import { TrendingUp, Flame } from 'lucide-react';

const trendingTags = [
  { name: 'AI Startups', count: 42, trending: true },
  { name: 'Funding News', count: 38, trending: true },
  { name: 'Women Founders', count: 29 },
  { name: 'Seed Round Stories', count: 26 },
  { name: 'SaaS Growth', count: 24 },
  { name: 'Fintech Innovation', count: 22 },
  { name: 'Y Combinator', count: 19 },
  { name: 'Product Launch', count: 17 },
  { name: 'Bootstrapped Success', count: 15 },
  { name: 'Startup Culture', count: 14 },
];

const popularReads = [
  {
    title: "How to Pitch VCs: The Ultimate Guide",
    views: "15.2K views",
  },
  {
    title: "Building in Public: Why It Works",
    views: "12.8K views",
  },
  {
    title: "First 100 Customers: Strategies That Work",
    views: "11.5K views",
  },
  {
    title: "Remote Team Management for Startups",
    views: "9.3K views",
  },
];

export const TrendingTopics = () => {
  return (
    <section className="py-16 sm:py-20 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Trending Topics */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <TrendingUp className="h-6 w-6 text-primary" />
              <h2 className="text-2xl sm:text-3xl font-bold font-heading">
                Trending Topics
              </h2>
            </div>
            <div className="flex flex-wrap gap-3">
              {trendingTags.map((tag, index) => (
                <motion.button
                  key={tag.name}
                  className="group relative"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Badge
                    variant="outline"
                    className="text-sm py-2 px-4 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 cursor-pointer"
                  >
                    {tag.trending && (
                      <Flame className="h-3 w-3 mr-1 text-primary group-hover:text-primary-foreground" />
                    )}
                    {tag.name}
                    <span className="ml-2 opacity-60">{tag.count}</span>
                  </Badge>
                </motion.button>
              ))}
            </div>
          </div>

          {/* Popular Reads */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <Flame className="h-6 w-6 text-primary" />
              <h2 className="text-2xl sm:text-3xl font-bold font-heading">
                Popular Reads
              </h2>
            </div>
            <div className="space-y-4">
              {popularReads.map((article, index) => (
                <button
                  key={index}
                  className="w-full text-left p-4 rounded-lg bg-card hover:bg-accent transition-colors group border border-transparent hover:border-primary/20"
                >
                  <div className="flex items-start gap-3">
                    <span className="text-2xl font-bold text-primary/30 group-hover:text-primary transition-colors">
                      {(index + 1).toString().padStart(2, '0')}
                    </span>
                    <div className="flex-1">
                      <h3 className="font-medium text-foreground group-hover:text-primary transition-colors mb-1">
                        {article.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {article.views}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
